import BlogHeroSection from "../components/Blogs/BlogHeroSection"
import BlogsSection from "../components/Blogs/BlogsSection"

const Blogs = () => {
  return (
    <>
    <BlogHeroSection/>
    <BlogsSection/>
    </>
  )
}

export default Blogs